export const normalizeLiabilitiesDetails = (rawSection = {}) => {
  const normalized = {
    loans: { ...(rawSection.loans || {}) },
    credit_cards: { ...(rawSection.credit_cards || {}) },
  };

  return normalized;
};

export const buildPersistedLiabilitiesDetails = (normalizedSection) => {
  return {
    loans: { ...normalizedSection.loans },
    credit_cards: { ...normalizedSection.credit_cards },
  };
};

export const createLoanId = (existingLoans) => {
  const keys = Object.keys(existingLoans);
  let nextNumber = keys.length + 1;
  while (keys.includes(String(nextNumber))) {
    nextNumber += 1;
  }
  return String(nextNumber);
};

export const createCreditCardId = (existingCards) => {
  const keys = Object.keys(existingCards);
  let nextNumber = keys.length + 1;
  while (keys.includes(String(nextNumber))) {
    nextNumber += 1;
  }
  return String(nextNumber);
};

export const buildEmptyLoan = () => {
  return {
    bank_name: "",
    owing: "",
    repayment: "",
    limit: "",
    held_by: "",
    payout: "",
    applicant1: false,
    applicant2: false,
  };
};

export const buildEmptyCreditCard = () => {
  return {
    bank_name: "",
    owing: "",
    limit: "",
    held_by: "",
    payout: "",
    applicant1: false,
    applicant2: false,
  };
};
